/**
 * Tier-A lifecycle shells — wire ScreenLifecycle + onDisposed for polling screens (GC-P0-03).
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTenantCode } from '../../../shared/tenant/TenantProvider.js';
import { ScreenLifecycle } from '../../../shared/screen/ScreenLifecycle.js';
import { PhoneFirstProductJourney } from '../PhoneFirstProductJourney.js';
import { PhoneFirstDonationJourney } from '../PhoneFirstDonationJourney.js';

function useCancelTenantCustomerQueries(): () => void {
  const queryClient = useQueryClient();
  const tenantCode = useTenantCode();
  return useCallback(() => {
    void queryClient.cancelQueries({ queryKey: ['customer', tenantCode] });
  }, [queryClient, tenantCode]);
}

export function PhoneFirstProductJourneyLifecycle(): JSX.Element {
  const onDisposed = useCancelTenantCustomerQueries();
  return (
    <ScreenLifecycle screenId="MS-COM-031" onDisposed={onDisposed}>
      <PhoneFirstProductJourney />
    </ScreenLifecycle>
  );
}

export function PhoneFirstDonationJourneyLifecycle(): JSX.Element {
  const onDisposed = useCancelTenantCustomerQueries();
  return (
    <ScreenLifecycle screenId="MS-COM-035" onDisposed={onDisposed}>
      <PhoneFirstDonationJourney />
    </ScreenLifecycle>
  );
}
